import styled from 'styled-components';
import { BLACK_60, RED_100 } from '@gr-monorepo/common/public/ui/constants/colors';

export const FilePlateWrap = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  width: 100%;
`;

export const FilePlateBox = styled.div<{ isError?: boolean }>`
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 0 0 calc((100% - 32px) / 5);
  min-width: 176px;
  max-width: calc((100% - 32px) / 5);
  box-sizing: border-box;
  padding: 12px;
  border-radius: 16px;
  background: #fff;
  border: 1px solid ${({ isError }) => (isError ? RED_100 : 'rgba(9, 21, 38, 0.1)')};
  overflow: hidden;
`;

export const FilePlateIcon = styled.div`
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;

  svg {
    display: block;
    width: 24px;
    height: 24px;
  }
`;

export const FileName = styled.span`
  flex: 1;
  min-width: 0;
  color: var(--font-color);
  font-size: 16px;
  line-height: 22px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const FilePlateCloseButton = styled.button`
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  padding: 0;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: ${BLACK_60};
  cursor: pointer;

  &:hover,
  &:focus {
    outline: none;
    background: var(--black-5);
    color: var(--font-color);
  }

  svg {
    display: block;
    width: 16px;
    height: 16px;

    path {
      fill: currentColor;
    }
  }
`;

export const FilePlatePreviewIconWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const ErrorText = styled.span`
  display: block;
  width: 100%;
  margin-top: 8px;
  color: ${RED_100};
  font-size: 16px;
  line-height: 22px;
`;
